angular.module 'app'
.controller 'SelectPeopleCtrl', ($rootScope, $timeout, $scope, $http, $stateParams, $state, config, Storage, dialogs, growl, SweetAlert, $uibModalInstance, data) ->

  $scope.ui =
    resourcesUrl: config.resources.baseUrl
    user: Storage.get('login_user')
    isLoading: false
    isGroupLoading: false
    currentPage: 1
    perPage: 8
    maxSize: 8
    totalItems: 0
    isSelectAll: false
    choseFans: []
    fans: []
    ungroups: [
        name: '全部'
        tag_id: 'all'
        tag_count: 0
    ]
    activeGroup:
      name: '全部'
      tag_id: 'all'
    groups: []
    search:
      nickname: null
    tipText: data.text

  if data.openid
    $scope.ui.choseFans = data.openid

  # 查詢粉絲分組
  findGroups = ->
    $scope.ui.isGroupLoading = true
    $http.get "#{config.api.baseUrl}/#{$stateParams.original_id}/follower/tag?access_token=" + Storage.get('access_token'), {}
    .then (res) ->
      $scope.ui.groups = []
      $scope.ui.groups = _.union($scope.ui.ungroups, res.data.data)
    .finally ->
      $scope.ui.isGroupLoading = false
    .catch (error) ->
      if error.data.error.indexOf('errtext') >= 0
        err = JSON.parse error.data.error
        growl.error err.errtext
      else
        growl.error('網絡連接失敗，請稍後重試')

  findDatas = ->
    $scope.ui.isLoading = true
    $scope.ui.isSelectAll = false
    $http.get "#{config.api.baseUrl}/#{$stateParams.original_id}/follower/infors/#{$scope.ui.activeGroup.tag_id}?access_token=" + Storage.get('access_token'),
      params:
        nickname: $scope.ui.search.nickname
        limit: $scope.ui.perPage
        offset: ($scope.ui.currentPage - 1) * $scope.ui.perPage
        sort: "-subscribe_time"
    .then (res) ->
      $scope.ui.ungroups[0].tag_count = res.data.count if $scope.ui.ungroups[0].tag_count < 1

      $scope.ui.totalItems = res.data.count
      $scope.ui.fans = res.data.data
      _.each $scope.ui.fans, (fan) ->
        fan.group_name = $scope.ui.activeGroup.name
        fan.isChecked = false
        fan.isChecked = true if _.contains $scope.ui.choseFans, fan.openid
        fan.subscribe_time = moment(fan.subscribe_time).format('YYYY-MM-DD')
        fan.tags = []
        _.each fan.tagid_list, (id) ->
          _.each $scope.ui.groups, (group) ->
            if String(id) is group.tag_id
              fan.tags.push group.name
    .finally ->
      $scope.ui.isLoading = false
    .catch (error) ->
      if error.data.error.indexOf('errtext') >= 0
        err = JSON.parse error.data.error
        growl.error err.errtext
      else
        growl.error('網絡連接失敗，請稍後重試')

  $scope.search = ->
    $scope.ui.totalItems = 0
    $scope.ui.fans = []
    $scope.ui.currentPage = 1
    findDatas()

  # 按下 Enter 鍵查詢
  $scope.keyUp = (e) ->
    keycode = if window.event then e.keyCode else e.which
    if keycode == 13
      $scope.ui.totalItems = 0
      $scope.ui.fans = []
      $scope.ui.currentPage = 1
      findDatas()

  $scope.selectAll = ->
    if $scope.ui.isSelectAll
      _.each $scope.ui.fans, (fan) ->
        $scope.ui.choseFans.push fan.openid if !_.contains $scope.ui.choseFans
        fan.isChecked = $scope.ui.isSelectAll
      $scope.ui.tipText = "已選粉絲 #{$scope.ui.choseFans.length} 人。"
    else
      _.each $scope.ui.fans, (fan) ->
        $scope.ui.choseFans = _.filter $scope.ui.choseFans, (val) ->
          val if val isnt fan.openid
        fan.isChecked = $scope.ui.isSelectAll
      $scope.ui.tipText = data.text

  $scope.deleteSelect = ->
    $scope.ui.choseFans = []
    $scope.ui.tipText = ''
    $scope.ui.isSelectAll = false
    _.each $scope.ui.fans, (fan) ->
      fan.isChecked = false

  # 選中左邊標簽
  $scope.setActiveGroup = (group) ->
    $scope.ui.activeGroup = group
    $scope.ui.totalItems = 0
    $scope.ui.fans = []
    $scope.ui.currentPage = 1
    findDatas()

  $scope.changeSelectFan = (fan) ->
    if fan.isChecked
      if data.single == true
        if $scope.ui.choseFans.length == 0
          $scope.ui.choseFans.push fan.openid if !_.contains $scope.ui.choseFans, fan.openid
        else
          fan.isChecked = false
          growl.error "只可選擇一名運營者微信號"
      else
        $scope.ui.choseFans.push fan.openid if !_.contains $scope.ui.choseFans, fan.openid
    else
      $scope.ui.choseFans = _.filter $scope.ui.choseFans, (val) ->
        val if val isnt fan.openid
    if $scope.ui.choseFans.length is 0
      $scope.ui.tipText = data.text
    else
      $scope.ui.tipText = "已選粉絲 #{$scope.ui.choseFans.length} 人。"

  $scope.cancel = ->
    $uibModalInstance.close 'Cancel'

  $scope.save = ->
    return growl.error "請選擇粉絲" if $scope.ui.choseFans.length < 1
    $uibModalInstance.close $scope.ui.choseFans

  findGroups()
  $scope.$watch 'ui.currentPage', findDatas
